/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Save_As_New_CopyInputs */

const en_save_as_new_copy = /** @type {(inputs: Save_As_New_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save as New Copy`)
};

const fr_save_as_new_copy = /** @type {(inputs: Save_As_New_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer comme nouvelle copie`)
};

const de_save_as_new_copy = /** @type {(inputs: Save_As_New_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als neue Kopie speichern`)
};

const it_save_as_new_copy = /** @type {(inputs: Save_As_New_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva come nuova copia`)
};

const ru_save_as_new_copy = /** @type {(inputs: Save_As_New_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранить как новую копию`)
};

const es_save_as_new_copy = /** @type {(inputs: Save_As_New_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar como nueva copia`)
};

const zh_cn2_save_as_new_copy = /** @type {(inputs: Save_As_New_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`另存为新副本`)
};

const ja_save_as_new_copy = /** @type {(inputs: Save_As_New_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいコピーとして保存`)
};

const hi_save_as_new_copy = /** @type {(inputs: Save_As_New_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नई प्रति के रूप में सहेजें`)
};

const pt_pt2_save_as_new_copy = /** @type {(inputs: Save_As_New_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar como nova cópia`)
};

/**
* | output |
* | --- |
* | "Save as New Copy" |
*
* @param {Save_As_New_CopyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const save_as_new_copy = /** @type {((inputs?: Save_As_New_CopyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Save_As_New_CopyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_save_as_new_copy(inputs)
	if (locale === "de") return de_save_as_new_copy(inputs)
	if (locale === "it") return it_save_as_new_copy(inputs)
	if (locale === "ru") return ru_save_as_new_copy(inputs)
	if (locale === "es") return es_save_as_new_copy(inputs)
	if (locale === "zh-CN") return zh_cn2_save_as_new_copy(inputs)
	if (locale === "ja") return ja_save_as_new_copy(inputs)
	if (locale === "hi") return hi_save_as_new_copy(inputs)
	if (locale === "pt-PT") return pt_pt2_save_as_new_copy(inputs)
	return en_save_as_new_copy(inputs)
});